/**
 * ViewInvoiceSupplierWrapper
 *
 * Purpose:
 * - Wraps supplier invoice view to ensure back navigation returns to vendor invoices with correct tab.
 */
import React from "react";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import { SUPPLIERS, VENDOR_PAYMENT, VENDOR, VENDOR_INVOICES } from "../../constants/route-paths";
import ViewInvoicePurchaseOrder from '../suppliers/vendor-payment/view-invoice';
import { VENDOR_TAB, VENDOR_URL_PARAM } from "../../constants/vendor.contant";

function ViewInvoiceSupplierWrapper(props) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const params = useParams();

  const returnTab = searchParams.get(VENDOR_URL_PARAM.RETURN_TAB) || VENDOR_TAB.SUPPLIER_INVOICES;
  const returnSubTab = searchParams.get(VENDOR_URL_PARAM.RETURN_SUB_TAB);

  // Override the history prop to handle return navigation
  const customHistory = (path) => {
    if (returnTab && path.includes(`/${SUPPLIERS}/${VENDOR_PAYMENT}`)) {
      // Return to vendor invoices with the correct tab and subTab
      const subTabQuery = returnSubTab ? `&${VENDOR_URL_PARAM.SUB_TAB}=${returnSubTab}` : '';
      navigate(`/${VENDOR}/${VENDOR_INVOICES}?${VENDOR_URL_PARAM.TAB}=${returnTab}${subTabQuery}`);
    } else {
      navigate(path);
    }
  };

  return (
    <ViewInvoicePurchaseOrder
      {...props}
      params={params}
      history={customHistory}
    />
  );
}

export default ViewInvoiceSupplierWrapper;
